export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  link: (key) => `nav-link-${key}`,
  ctaQuote: "nav-cta-quote",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const PRICING = {
  toggle: (which) => `pricing-toggle-${which}`,
  card: (id) => `pricing-card-${id}`,
  buy: (id) => `pricing-buy-${id}`,
};

export const LEAD = {
  open: "lead-form-open",
  name: "lead-input-name",
  email: "lead-input-email",
  phone: "lead-input-phone",
  business: "lead-input-business",
  details: "lead-input-details",
  package: "lead-input-package",
  submit: "lead-submit",
};

export const PORTFOLIO = {
  card: (id) => `portfolio-card-${id}`,
  visit: (id) => `portfolio-visit-${id}`,
};

export const ADMIN = {
  passwordInput: "admin-password-input",
  loginBtn: "admin-login-btn",
  logoutBtn: "admin-logout-btn",
  statsTotalLeads: "admin-stat-total-leads",
  statsRevenue: "admin-stat-revenue",
  leadsTable: "admin-leads-table",
  paymentsTable: "admin-payments-table",
  projectsTable: "admin-projects-table",
  projectNewBtn: "admin-project-new-btn",
  projectEditBtn: (id) => `admin-project-edit-${id}`,
  projectCopyLink: (id) => `admin-project-copy-${id}`,
  projectAdvanceStage: (id) => `admin-project-advance-${id}`,
};

export const TRACK = {
  page: "track-page",
  stage: (i) => `track-stage-${i}`,
  progress: "track-progress-bar",
};
